<div class="fg-card">
  <div class="fg-close" (click)="dismiss()">
    <span class="material-icons">close</span>
  </div>
  <div class="fg-icon">
    <span class="material-icons">lock_open</span>
  </div>
  <div class="fg-title">
    <tidy-text [largeTitle]="title" />
  </div>

  @if (isRentalClient) {
    <!-- Account manager: photo + name, then the three reach-out actions. Mirrors the
         My Account page's account-manager card so the two feel like the same person. -->
    <div class="fg-manager">
      <img [src]="managerPhoto" class="fg-manager-avatar" [alt]="managerName" />
      <div class="fg-manager-identity">
        <span class="fg-manager-eyebrow">Account Manager</span>
        <tidy-text [body]="managerName" class="fg-manager-name" />
      </div>
    </div>

    <div class="fg-actions">
      <tidy-small-button [text]="'Email'" [image]="'assets/svg/mail-outline.svg'" (buttonClick)="email()" />
      <tidy-small-button [text]="'Text'" [image]="'assets/svg/chatbox-ellipses-outline.svg'" (buttonClick)="text()" />
      <tidy-small-button [text]="'Schedule'" [image]="'assets/svg/calendar-outline.svg'" (buttonClick)="schedule()" />
    </div>
  } @else {
    <div class="fg-actions">
      <tidy-small-button [text]="'Contact Us'" [image]="'assets/svg/chatbox-ellipses-outline.svg'" (buttonClick)="contactUs()" />
    </div>
  }
</div>
